import { read } from './http';
import { MOCK_HISTORY, MOCK_PROFILE, MOCK_SUMMARY } from './mock/manager.mock';
import type { GameweekPoints, ManagerProfile, ManagerSummary } from '@/types';

/** GET /managers/me */
export function getManagerProfile(signal?: AbortSignal): Promise<ManagerProfile> {
  return read('/managers/me', () => MOCK_PROFILE, signal);
}

/** GET /managers/me/summary — standings for the current gameweek. */
export function getManagerSummary(signal?: AbortSignal): Promise<ManagerSummary> {
  return read('/managers/me/summary', () => MOCK_SUMMARY, signal);
}

/** GET /managers/me/history — points and rank per gameweek this season. */
export function getManagerHistory(signal?: AbortSignal): Promise<readonly GameweekPoints[]> {
  return read('/managers/me/history', () => MOCK_HISTORY, signal);
}
